export default __webpack_public_path__ + "static/media/0x2fe8733dcb25bfbba79292294347415417510067.e1d594ca.jpeg";